import type { ReactNode } from "react";
import { Link } from "react-router-dom";

type SectionTitleProps = {
  eyebrow?: string;
  title: string;
  desc?: string;
  linkTo?: string;
  linkLabel?: string;
  children?: ReactNode;
};

const SectionTitle = ({ eyebrow, title, desc, linkTo, linkLabel, children }: SectionTitleProps) => (
  <div className="flex flex-col gap-4 border-t-2 border-foreground-950/80 pt-5 sm:flex-row sm:items-end sm:justify-between">
    <div>
      {eyebrow && (
        <p className="font-label text-xs tracking-[0.28em] text-primary-600">{eyebrow}</p>
      )}
      <h2 className="mt-2 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
        {title}
      </h2>
      {desc && <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{desc}</p>}
    </div>
    {children}
    {linkTo && linkLabel && (
      <Link
        to={linkTo}
        className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap font-label text-sm text-primary-600 transition-colors hover:text-primary-700"
      >
        {linkLabel}
        <i className="ri-arrow-right-line text-base"></i>
      </Link>
    )}
  </div>
);

export default SectionTitle;